import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Logo } from "@/ui/layout";

export const Route = createFileRoute("/_app/_auth/onboarding/_layout")({
  component: OnboardingLayout,
});

export default function OnboardingLayout() {
  return (
    <div className="relative flex h-screen w-full bg-card">
      <div className="absolute left-1/2 top-8 mx-auto -translate-x-1/2 transform justify-center">
        <Logo />
      </div>
      <div className="z-10 h-screen w-screen">
        <Outlet />
      </div>
      <div className="base-grid fixed h-screen w-screen opacity-40" />
      <div className="fixed bottom-0 h-screen w-screen bg-gradient-to-t from-[hsl(var(--card))] to-transparent" />
    </div>
  );
}
